import {useQuery} from "@tanstack/react-query";
import {Channel} from "@/models";
import * as _a from "@/lib/api";

export const useChannel = (cid: Channel['cid']) => {
  return useQuery({
    queryKey: ['channels', cid],
    queryFn: () => _a.channel(cid)
  });
}